import { Directive, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { throttleTime } from 'rxjs/operators';

/**
 * Add throttle time to button clicks to e.g. prevent submitting form multiple times
 */
@Directive({
    selector: '[appThrottleClick]',
    standalone: true
})
export class ThrottleButtonClickDirective implements OnInit, OnDestroy {
  @Input()
  throttleTime = 3000;

  @Output()
  throttledClick = new EventEmitter();

  private clicks = new Subject<void>();
  private subscription: Subscription;

  constructor() { }

  ngOnInit() {
    this.subscription = this.clicks.pipe(
      throttleTime(this.throttleTime)
    ).subscribe(e => this.emitThrottledClick(e));
  }

  emitThrottledClick(e) {
    this.throttledClick.emit(e);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  @HostListener('click', ['$event'])
  clickEvent(event) {
    event.preventDefault();
    event.stopPropagation();
    this.clicks.next(event);
  }

}
